import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=5edb1894&scoped=true&lang=pug"
import script from "./confirm.vue?vue&type=script&lang=js"
export * from "./confirm.vue?vue&type=script&lang=js"
import style0 from "./dialogs.scss?vue&type=style&index=0&id=5edb1894&prod&lang=scss&scoped=true&external"
import style1 from "./confirm.vue?vue&type=style&index=1&id=5edb1894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edb1894",
  null
  
)

export default component.exports